module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-error-66509a16.svg";